import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlMaker } from 'src/app/commons/url-maker';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { TbAuthService } from '@tb/auth';
import { NewOperationResult } from './operation-result-new';
import { CourseProgram } from 'src/app/model/course-program';
import { MacroAreaEnvironments } from 'src/app/model/macroarea-environments';
import { LoginService } from './login.service';
import { ProductLearningArea } from 'src/app/model/ProductLearningArea';
@Injectable({
    providedIn: 'root',
})
export class CoursesService {
    storeApiUrl: string;
    microareaserviceproxy: string;
    universityBaseUrl: string;

    constructor(private http: HttpClient, private tbAuthService: TbAuthService, private loginService: LoginService) {
        this.storeApiUrl = environment.settings.storeApiUrl;
        this.microareaserviceproxy = environment.settings.microareaserviceproxy;
        this.universityBaseUrl = environment.settings.universityBaseUrl
    }

    public async getAllCourses(trainingPlans: boolean)  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getAllCoursePrograms')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter('trainingPlans', trainingPlans)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = { "authToken": environment.auth.authToken }

        const bodyString = JSON.stringify(reqBody);
        return this.http
        .post<NewOperationResult<CourseProgram[]>>(url.toString(), bodyString, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getAllCourses')))
        .toPromise();
    }

    public async getExtendedCourseProgram(courseName: string)  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getExtendedPlanCourse')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter('courseName', courseName)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = { "authToken": environment.auth.authToken }

        const bodyString = JSON.stringify(reqBody);
        return this.http
        .post<NewOperationResult<CourseProgram>>(url.toString(), bodyString, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getExtendedCourseProgram')))
        .toPromise();
    }

    public async getAllMacroAreaEnvironments(){
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getAllMacroAreaEnvironments')
            .appendSegment(this.tbAuthService.getAccountName())
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = { "authToken": environment.auth.authToken }

        const bodyString = JSON.stringify(reqBody);
        return this.http
            .post<NewOperationResult<MacroAreaEnvironments[]>>(url.toString(), bodyString, { headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getAllMacroAreaEnvironments')))
            .toPromise();
    }

    public async generateCorseToken(courseMaterial: string): Promise<NewOperationResult<string>>{
        let url = new UrlMaker()
            .appendBaseUrl(this.microareaserviceproxy)
            .appendSegment('api')
            .appendSegment('generateCourseToken')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter('pageName', courseMaterial)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = { "authToken": environment.auth.authToken }

        const bodyString = JSON.stringify(reqBody);
        return this.http
            .post<NewOperationResult<string>>(url.toString(), bodyString, { headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in generateCorseToken')))
            .toPromise();
    }

    public openCourse(courseMaterial: string, token: string){
        let url: string = ''
        if(!courseMaterial.includes("https://")){
            url = new UrlMaker()
                .appendBaseUrl(`${this.microareaserviceproxy}${courseMaterial}`)
                .appendParameter('sessionId', token)
                .toString()
                .replace('/?', '?')
        }
        else
            url = courseMaterial
        window.open(url)
    }

    public getCourseLink(courseMaterial: string): string{
        return courseMaterial.includes('http') ? courseMaterial : `${this.universityBaseUrl}${courseMaterial}`
    }

    public async getAllProductLearningAreas(){
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getAllProductLearningAreas')
            .appendSegment(this.tbAuthService.getAccountName())
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = { "authToken": environment.auth.authToken }

        const bodyString = JSON.stringify(reqBody);
        return this.http
            .post<NewOperationResult<ProductLearningArea[]>>(url.toString(), bodyString, { headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getAllProductLearningAreas')))
            .toPromise();
    }

    public async setDirectCourseLink(directCourseLink: string){
      let url = new UrlMaker()
          .appendBaseUrl(this.storeApiUrl)
          .appendSegment('setDirectCourseLink')
          .appendParameter("directCourseLink", directCourseLink)
          .toString()
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http
          .post(url.toString(), null, { headers })
          .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in setDirectCourseLink')))
          .toPromise();
    }

    public async getDirectCourseLink(){
      let url = new UrlMaker()
          .appendBaseUrl(this.storeApiUrl)
          .appendSegment('getDirectCourseLink')
          .toString()
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http
          .post<NewOperationResult<string>>(url.toString(), null, { headers })
          .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getDirectCourseLink')))
          .toPromise();
    }


}
